import TransferInvByTaxCodeAPI from '../../api/TransferInvByTaxCodeAPI';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';
export default {
	deleteTransferInv: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: TransferInvByTaxCodeAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/remove-transferinvbytaxcode',
			data: payload
		});
		return res;
	},

	addTransferInv: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: TransferInvByTaxCodeAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				data: payload
			},
			true
		);
		return res;
	},

	updateTransferInv: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: TransferInvByTaxCodeAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/update-transferinvbytaxcode',
			data: payload
		});
		return res;
	},

	getPagingTransferInv: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: TransferInvByTaxCodeAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				params: payload
			},
			true
		);
		if (res && res.Success) {
			context.commit('setData', res.Data);
		}
		return res;
	},

	getTotalRecordTransferInv: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: TransferInvByTaxCodeAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/total'
			},
			true
		);
		if (res && res.Success) {
			context.commit('setTotalPage', res.Data);
		}
		return res;
	}
};
